module.exports = __webpack_public_path__ + "img/show_more.166057ff.png";